import React from 'react';
import resources from '../../resources';
import { Row, Col } from 'antd';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';
import StatItem4 from '../BaseComponents/StatItem4';

class Game2024Content extends React.Component {

  render() {
    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].Game2024Content; // có thể dùng dynamic switch

    var combinedStats = [];
    const maxLength = lang.statsLeft.length
    if(combinedStats.length == 0){
      for (var i = 0; i < maxLength; i++) {
        combinedStats.push(lang.statsLeft[i])
        combinedStats.push(lang.statsRight[i])
      }
    }
    const {isMobile} = StoreManager.appState.thisApp.state
    

    return (
      <div style={{ lineHeight: 1.6 }}>
      
        {/* Heading */}
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{lang.title}</h2>

        {/* Context */}
        <div style={{ marginTop: 24 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.contextTitle}</h4>
          <p>{lang.contextText}</p>
        </div>

        {/* Banner Image */}
        <div style={{ margin: '24px 0' }}>
          <img src={resources.images.Game2024Image1} alt="Game banner" style={{ width: '100%', borderRadius: 16 }} />
        </div>

        {/* Legacy Section */}
        <div style={{ marginBottom: 24 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.legacyTitle}</h4>
          <p>{lang.legacyText}</p>
        </div>

    {/* Six Icon Cards */}
    <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 12 }}>
    <Row gutter={[12, 24]} style={{ marginTop: 24, marginBottom: 48 }}>
    {combinedStats.map((item, index) => (
      <Col
        key={index}
        xs={24}
        md={index % 2 == 1 ? 14 : 10}
        // Nếu tổng số item lẻ, thì item cuối md=24
      >
        <StatItem4
          iconName={item.icon}
          value={item.value}
          message1={item.text}
        />
      </Col>
    ))}
  </Row>
</div>



        {/* Product Expansion */}
        <div style={{ marginBottom: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.productExpansionTitle}</h4>
          <p>{lang.productExpansionText1}</p>
          <p>{lang.productExpansionText2}</p>
          <p>{lang.productExpansionText3}</p>
          <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
            <Col xs={24}>
              <img src={resources.images.Game2024Image2} alt="AI banner" style={{ width: '100%', borderRadius: 16 }} />
            </Col>
            <Col xs={24}>
              <Row gutter={[0, 16]} style={{ justifyContent: 'space-around' }}>
                <Col span={11}>
                  <img src={resources.images.Game2024Image3} alt="Artian" style={{ width: '100%', borderRadius: 16 }} />
                </Col>
                <Col span={11}>
                  <img src={resources.images.Game2024Image4} alt="Artist" style={{ width: '100%', borderRadius: 16 }} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        {/* Gaming Ecosystem */}
        <div style={{ marginBottom: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.studioCultureTitle}</h4>
          <p>{lang.studioCultureText}</p>
          <img src={resources.images.Game2024Image5} alt="Esport" style={{ width: '100%', borderRadius: 8 }} />
        </div>

        {/* People Culture */}
        <div style={{ marginBottom: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.peopleCultureTitle}</h4>
          <p>{lang.peopleCultureText}</p>
          <Row gutter={[0, 16]} style={{ justifyContent: 'space-around' }}>
            <Col span={11}>
              <img src={resources.images.Game2024Image6} alt="Culture 1" style={{ width: '100%', borderRadius: 16 }} />
            </Col>
            <Col span={11}>
              <img src={resources.images.Game2024Image7} alt="Culture 2" style={{ width: '100%', borderRadius: 16 }} />
            </Col>
          </Row>
        </div>

        {/* Vision */}
        <div style={{ marginBottom: 80 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.visionTitle}</h4>
          <p>{lang.visionText}</p>
        </div>
      </div>
    );
  }
}

export default Game2024Content;
